export default __webpack_public_path__ + "static/okun-a7cd6abed3bc20bf2e8633dfea91f22f.png";